import "./Home.css";

const Home = ({ children }) => {
  return (
    <div className="home">
        {children}
        {/* TODO QUOTE HERE and button for another one */}
    </div>
  );
};

export default Home;
